"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var wechatOpenPlatformRouter = {
  path: '/wechatOpenPlatform',
  component: _layout.default,
  redirect: '/wechatOpenPlatform/index',
  name: 'wechatOpenPlatform',
  meta: {
    title: '微信服务商',
    icon: 'wechat'
  },
  children: [{
    path: 'index',
    name: 'wechatOpenPlatformIndex',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/wechatOpenPlatform'));
      });
    },
    meta: {
      title: '服务商管理',
      icon: ''
    }
  }, {
    path: 'miniProgramVersion',
    name: 'wechatOpenPlatformMiniProgramVersion',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/wechatOpenPlatform/miniProgramVersion'));
      });
    },
    meta: {
      title: '小程序版本管理',
      icon: ''
    }
  }]
};
var _default = exports.default = wechatOpenPlatformRouter;